import theme from "./theme";

export const male = "maschietto";
export const female = "femminuccia";

export const personalities = [
  "ISFP",
  "ISTP",
  "ESFP",
  "ESTP",
  "ISTJ",
  "ISFJ",
  "ESFJ",
  "ESTJ",
  "ENFP",
  "INFJ",
  "INFP",
  "ENFJ",
  "INTP",
  "ENTJ",
  "ENTP",
  "INTJ"
];

export const ageGroups = [
  {
    min: -Infinity,
    max: 18
  },
  {
    min: 18,
    max: 25
  },
  {
    min: 25,
    max: 30
  },
  {
    min: 30,
    max: 35
  },
  {
    min: 35,
    max: +Infinity
  }
];

export const getAge = birthday => {
  const ageDifMs = Date.now() - birthday.getTime();
  const ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};

export const getPersonality = personality => {
  if (!personality) return;
  const got = personalities.reduce((actual, current) => {
    if (personality.toLowerCase().includes(current.toLowerCase()))
      actual = current;

    return actual;
  }, undefined);

  return got;
};

export const capitalize = string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const colors = [
  theme.yellow,
  theme.pink,
  theme.magenta,
  theme.blue,
  theme.aqua
];
